// extracted by mini-css-extract-plugin
module.exports = {"gallery":"GallerySlider_gallery__1Yylt","mainImage":"GallerySlider_mainImage__G0Xho"};